import { EntryScreen } from '@/components/entry/entry-screen';

export default function PartnerLoginPage() {
  return <EntryScreen variant="owner" />;
}
